import React from 'react'
import * as S from './style'
import { SelectProps } from '../../types/components/select'

export const Select: SelectProps = ({
  text,
  array,
  value,
  handleChange,
  isValidate = true,
  widthDiv = '100%',
  label,
  disabled
}) => {
  return (
    <S.Container widthDiv={widthDiv}>
      {label && label?.length > 0 && <S.Label isValidate={isValidate}>{label}</S.Label>}
      <S.DivSelect>
        <S.SelectComp name={text} id={text} value={value} onChange={handleChange} disabled={disabled}>
          <option selected disabled>
            {text}
          </option>
          {array && array[0] !== 'sim' && <option value="">Todos(as)</option>}
          {array &&
            array.map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
        </S.SelectComp>
      </S.DivSelect>
    </S.Container>
  )
}
